var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManagementIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5093_40663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2695 19.0518L21.2695 5.05176C21.2695 3.95176 20.3695 3.05176 19.2695 3.05176L5.26953 3.05176C4.16953 3.05176 3.26953 3.95176 3.26953 5.05176L3.26953 19.0518C3.26953 20.1518 4.16953 21.0518 5.26953 21.0518L19.2695 21.0518C20.3695 21.0518 21.2695 20.1518 21.2695 19.0518ZM5.26953 19.0518L5.26953 5.05176L19.2695 5.05176L19.2695 19.0518L5.26953 19.0518ZM14.2695 7.05176L14.2695 9.05176L7.26953 9.05176L7.26953 7.05176L14.2695 7.05176ZM17.2695 11.0518L17.2695 13.0518L7.26953 13.0518L7.26953 11.0518L17.2695 11.0518ZM11.2695 15.0518L11.2695 17.0518L7.26953 17.0518L7.26953 15.0518L11.2695 15.0518Z",
    fill: "#B9B9B9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5093_40663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24.2695 0.0517578) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementIcon);
export default __webpack_public_path__ + "static/media/management-icon.9f5a0c0818674bd94d13dff644154eeb.svg";
export { ForwardRef as ReactComponent };